window.addEventListener('load', () => {
  const isMobileOrTablet = window.matchMedia('(max-width: 1024px)').matches;
  const isMobile = window.matchMedia('(max-width: 640px)').matches;
  let googleIcon = document.querySelector('.google-preferred');
  let shareIcons = document.querySelectorAll('.social-icon-share');
  let tooltip = document.querySelector('.custom-tooltip');

  if (isMobile) {
    // Full width articles load social_icons.html twice, once for desktop and a second time
    // for mobile, we search in the mobile container to find that the correct elements are selected
    const mobileContainer = document.querySelector('.full-width__social-mobile');
    if (mobileContainer) {
      // Select the Google icon and tooltip from mobile container
      googleIcon = mobileContainer.querySelector('.google-preferred');
      tooltip = mobileContainer.querySelector('.custom-tooltip');

      // Get all visible share icon container
      // The desktop container is hidden via CSS, so we need to exclude it
      const desktopContainer = document.querySelector('.full-width__actions-desktop');
      shareIcons = Array.from(document.querySelectorAll('.social-icon-share')).filter((icon) => {
        // Exclude icons that are inside the hidden desktop container
        return !desktopContainer || !desktopContainer.contains(icon);
      });
    }
  }

  // Tooltip styling
  const applyTooltipStyles = (tooltipElement) => {
    Object.assign(tooltipElement.style, {
      position: 'absolute',
      padding: '12px 16px',
      background: 'white',
      border: '1px solid #dddee6',
      borderRadius: '6px',
      boxShadow: '0px 0px 8px 0px rgba(120, 120, 140, 0.2)',
      maxWidth: '300px',
      fontSize: '14px',
      lineHeight: '1.4',
      zIndex: 99,
      opacity: 0,
      display: 'none',
      pointerEvents: 'auto',
    });
  };

  applyTooltipStyles(tooltip);

  // Reusable tooltip manager for handling hide timing
  const createTooltipManager = (tooltipElement) => {
    let hideTimeout = null;
    let displayTimeout = null;
    const element = tooltipElement;

    return {
      scheduleHide: () => {
        hideTimeout = setTimeout(() => {
          element.style.opacity = 0;
          displayTimeout = setTimeout(() => {
            element.style.display = 'none';
          }, 200);
        }, 200);
      },
      cancelHide: () => {
        if (hideTimeout) {
          clearTimeout(hideTimeout);
          hideTimeout = null;
        }
        if (displayTimeout) {
          clearTimeout(displayTimeout);
          displayTimeout = null;
        }
      },
    };
  };

  // Create manager for main tooltip
  const tooltipManager = createTooltipManager(tooltip);
  const { scheduleHide: scheduleHideTooltip, cancelHide: cancelHideTooltip } = tooltipManager;

  // Helper to position tooltip
  const positionTooltip = (trigger, toolTip, alignTextRight = false, positionAbove = false) => {
    /**
     * The purpose of this function is to help position the tooltip in various
     * scenarios that would not work if done in pure css.
     * These include positioning the tooltip right underneath the
     * correct icon(license, google preferred, share)
     * Sometimes the share tooltip gets cutoff on the left and
     * right side so we need to use js to help calculate and
     * adjust the tooltip back on the screen to correctly position it.
     * When positionAbove is true that means we are positioning the tooltip for
     * the below content so the tooltip will be displayed above the icons
     * instead of below it
     */
    const { scrollX, innerWidth } = window;
    const triggerRect = trigger.getBoundingClientRect();
    let left;
    let right;
    const tip = toolTip;
    tip.style.display = 'block';
    if (alignTextRight) {
      left = scrollX + triggerRect.right - tip.offsetWidth;
    } else {
      left = scrollX + triggerRect.left + triggerRect.width / 2 - tip.offsetWidth / 2;
    }
    // Check for right side cutoff
    const rightEdge = left + tip.offsetWidth;
    if (rightEdge > scrollX + innerWidth) {
      right = 10;
    }
    // Check for left side cutoff
    if (left < scrollX + 8) {
      left = scrollX + 8;
    }
    const { style } = tip;
    if (right) {
      style.right = `${right}px`;
    } else {
      style.left = `${left}px`;
    }

    // Position vertically above the social buttons for the below content.
    // Calculate 'top' relative to the tooltip's offsetParent (e.g., .page-container)
    // to ensure the position remains correct even if dynamic content (like ads)
    // shifts the entire container's position on the page.
    if (positionAbove) {
      const offsetParentTop = tip.offsetParent
        ? tip.offsetParent.getBoundingClientRect().top
        : 0;
      const top = triggerRect.top - offsetParentTop - tip.offsetHeight - 10;
      style.top = `${top}px`;
    }
  };

  const showTooltip = (content) => {
    tooltip.innerHTML = content;
    tooltip.style.display = 'block';
    tooltip.style.opacity = 1;
  };

  const buildTooltipContent = (tooltipText, closeButtonClass = null) => {
    if (!isMobileOrTablet) {
      return tooltipText;
    }

    const closeButtonHtml = closeButtonClass ? `<button class="${closeButtonClass}">&times;</button>` : '';

    return `<div style="position:relative; padding-right:24px;">
             <span>${tooltipText}</span>
             ${closeButtonHtml}
           </div>`;
  };

  // Google preferred tooltip
  if (googleIcon) {
    /**
     * Google preferred tooltip
     * Manually adding the html content for the x close button based on if the
     * current device is tablet or mobile because we are setting the contents of
     * the tooltip in showTooltip which will clear out everything in that element
     * so we cannot add the same close button since it will get cleared out everytime
     * we show the tooltip
     */

    const showGoogleTooltip = () => {
      // Cancel any pending hide tooltip action to prevent tooltip not showing
      // the tooltip if moving the mouse between license and google preferred too quickly
      cancelHideTooltip();
      // Check if the the current device is tablet/mobile and create the x button if so
      // if not then will just use the tooltip text for desktop
      const content = buildTooltipContent(googleIcon.dataset.tooltip, 'tooltip-close-btn');

      // Show the google preferred tooltip and position it near the google preferred element
      showTooltip(content);
      positionTooltip(googleIcon, tooltip, isMobileOrTablet);

      // Add close button functionality on tablet and mobile
      if (isMobileOrTablet) {
        const closeBtn = document.querySelector('.tooltip-close-btn');
        if (closeBtn) {
          closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            scheduleHideTooltip();
            // Use sessionStorage so the Google Preferred
            // tooltip only appears once per tab on mobile
            // After it's close, it won't show again in that
            // tab, but it will reappear in a new tab
            sessionStorage.setItem('googleTooltipClosed', 'true');
          });
        }
      }
    };

    // Desktop hover, show tooltip on hover
    if (!isMobileOrTablet) {
      googleIcon.addEventListener('pointerenter', showGoogleTooltip);
      googleIcon.addEventListener('pointerleave', scheduleHideTooltip);
    }

    // Automatically show the google preferred tooltip if the user on tablet/mobile
    if (isMobileOrTablet && sessionStorage.getItem('googleTooltipClosed') !== 'true') {
      showGoogleTooltip();
    }
  }

  // Handle top and bottom Google Preferred icons
  // This runs after the first one is handled above to maintain existing behavior
  const additionalGoogleIcons = document.querySelectorAll('.google-preferred');
  additionalGoogleIcons.forEach((additionalGoogleIcon, index) => {
    // Skip the first one as it's already handled above
    if (index === 0 || additionalGoogleIcon === googleIcon) return;

    const additionalTooltip = additionalGoogleIcon.closest('ul').nextElementSibling;

    // Return early if no additional tooltip elements are found
    if (!additionalTooltip || !additionalTooltip.classList.contains('custom-tooltip')) return;

    // Style the additional tooltip
    applyTooltipStyles(additionalTooltip);

    let hideTimeout = null;
    let displayTimeout = null;

    const cancelHideAdditionalTooltip = () => {
      // The footer/bottom tooltip can be re-hovered quickly; if we don't cancel any
      // pending hide timers, the old timer will still fire and hide it.
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
      if (displayTimeout) {
        clearTimeout(displayTimeout);
        displayTimeout = null;
      }
    };

    const fadeOutAndHideTooltip = (tooltipElement, delay = 0) => {
      cancelHideAdditionalTooltip();
      const tip = tooltipElement;
      hideTimeout = setTimeout(() => {
        tip.style.opacity = 0;
        displayTimeout = setTimeout(() => {
          tip.style.display = 'none';
        }, 200);
      }, delay);
    };

    const showAdditionalGoogleTooltip = () => {
      cancelHideAdditionalTooltip();
      const closeButtonClass = `tooltip-close-btn-${index}`;

      const content = buildTooltipContent(additionalGoogleIcon.dataset.tooltip, closeButtonClass);

      additionalTooltip.innerHTML = content;
      additionalTooltip.style.display = 'block';
      additionalTooltip.style.opacity = 1;

      // Position tooltip above if the google icon is in social-button-list
      const isInButtonList = additionalGoogleIcon.closest('.social-button-list');
      positionTooltip(additionalGoogleIcon, additionalTooltip, isMobileOrTablet, isInButtonList);

      if (isMobileOrTablet) {
        const closeBtn = additionalTooltip.querySelector(`.tooltip-close-btn-${index}`);
        if (closeBtn) {
          closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            fadeOutAndHideTooltip(additionalTooltip);
            // Use sessionStorage so the Google Preferred
            // tooltip only appears once per tab on mobile
            // After it's close, it won't show again in that
            // tab, but it will reappear in a new tab
            sessionStorage.setItem('googleTooltipClosed', 'true');
          });
        }
      }
    };

    const hideAdditionalGoogleTooltip = () => {
      fadeOutAndHideTooltip(additionalTooltip, 200);
    };

    // Desktop hover
    if (!isMobileOrTablet) {
      additionalGoogleIcon.addEventListener('pointerenter', showAdditionalGoogleTooltip);
      additionalGoogleIcon.addEventListener('pointerleave', hideAdditionalGoogleTooltip);
    }
  });

  // Handle top and bottom share icons on the same page
  const shareTooltips = [];

  const resetShareTooltipText = (tooltipElement) => {
    const textContent = window.gettext('Copy link');
    tooltipElement.querySelectorAll('.share-copy-link .social-icon__text')
      .forEach((span) => {
        // eslint-disable-next-line no-param-reassign
        span.textContent = textContent;
      });
  };

  const hideShareTooltipInstance = (tooltipElement) => {
    const tip = tooltipElement;
    tip.style.opacity = 0;
    setTimeout(() => {
      tip.style.display = 'none';
      resetShareTooltipText(tip);
    }, 200);
  };

  shareIcons.forEach((shareIcon) => {
    const shareTooltip = shareIcon.nextElementSibling;

    if (!shareTooltip) return;

    shareTooltips.push({ shareIcon, shareTooltip });

    // Tooltip styling
    Object.assign(shareTooltip.style, {
      border: '1px solid #dddee6',
      borderRadius: '6px',
      boxShadow: '0px 0px 8px 0px rgba(120, 120, 140, 0.2)',
    });

    // Displays the share tooltip when the Share button is clicked
    shareIcon.addEventListener('click', (e) => {
      e.stopPropagation();
      const isVisible = shareTooltip.style.display === 'block';
      if (isVisible) {
        hideShareTooltipInstance(shareTooltip);
      } else {
        shareTooltip.style.display = 'block';

        // Position tooltip above if the google icon is in social-button-list
        const isInButtonList = shareIcon.closest('.social-button-list');
        positionTooltip(shareIcon, shareTooltip, false, isInButtonList);

        shareTooltip.style.opacity = 1;
      }
    });
  });

  // Single event listeners for esc key and outside clicks
  if (shareTooltips.length > 0) {
    // Listen for the esc key to close any open tooltip
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        shareTooltips.forEach(({ shareTooltip }) => {
          if (shareTooltip.style.display === 'block') {
            hideShareTooltipInstance(shareTooltip);
          }
        });
      }
    });

    document.addEventListener('click', (e) => {
      const copyBtn = e.target.closest('.share-copy-link');

      // Functionality for the copy link button
      if (copyBtn) {
        navigator.clipboard.writeText(copyBtn.dataset.copyUrl)
          .then(() => {
            const textSpan = copyBtn.querySelector('.social-icon__text');
            if (textSpan) {
              textSpan.textContent = window.pgettext('refers to copy and paste action', 'Copied!');
            }
          }).catch(() => console.error('Failed to copy link.'));
        return;
      }

      // Close any tooltip if clicked outside
      shareTooltips.forEach(({ shareIcon, shareTooltip }) => {
        if (!shareIcon.contains(e.target) && !shareTooltip.contains(e.target)) {
          if (shareTooltip.style.display === 'block') {
            hideShareTooltipInstance(shareTooltip);
          }
        }
      });
    });
  }

  // License tooltip
  const licenseIcon = document.querySelector('.js-social-icon-license');
  // We only want to display the tooltip on desktop only
  if (licenseIcon && !isMobileOrTablet) {
    // Display and position the tooltip for license article
    const showLicenseTooltip = () => {
      // Cancel any pending hide tooltip action to prevent tooltip not showing
      // when moving the mouse between icons (google, license) too quickly
      cancelHideTooltip();
      showTooltip(licenseIcon.dataset.tooltip);
      positionTooltip(licenseIcon, tooltip);
    };
    // Displays the tooltip on mouse hover
    licenseIcon.addEventListener('pointerenter', showLicenseTooltip);
    licenseIcon.addEventListener('pointerleave', scheduleHideTooltip);
  }
});
